(function () {
    'use strict';

    angular
        .module('ResourceGenerator')
        .factory('GenericModel', GenericModel);

    function GenericModel($resource, AbstractModelService) {
        return function(url, modelOptions, canceller) {
            var actions;
            if (modelOptions) {
                actions = AbstractModelService(url, modelOptions);
            } else {
                actions = AbstractModelService();
            }
            //var actions =
            const cancellerObj = {};
            if (canceller) {
                cancellerObj.timeout = canceller;
            }

            const params = angular.merge(
                {},
                {
                    id: '@id'
                },
                cancellerObj
            );

            return $resource(
                url,
                params,
                actions
            );
        };
    }
})();